<template>
  <section :class="$style.container">
    <UserLoginController
      v-if="isIdentityFirstFlow"
      :mfaType="mfaType"
      :paramError="error"
      :step="step"
      v-bind="$props"
    />
    <div v-else>
      <ButtonLoginSwitch
        v-if="!redirectTo"
        :clickHandler="goToAdminLogin"
      >
        Administrator Login
      </ButtonLoginSwitch>
      <div
        :class="$style.formContainer"
      >
        <UserLoginForm
          :autofocus="autofocus"
          :form="form"
          :goToAdminLogin="goToAdminLogin"
          :loadingErrorMsg="error"
          :loadingSuccessMsg="success"
          :updateAutofocus="updateAutofocus"
          v-bind="$props"
        />
        <LogoIcon />
      </div>
    </div>
  </section>
</template>

<script>
import { useFeatureFlags } from 'client/stores/FeatureFlag';
import ButtonLoginSwitch from 'client/components/ButtonLoginSwitch.vue';
import Constants from 'client/util/Constants';
import Cookies from 'js-cookie';
import LoginConsts from 'client/util/Constants/LoginConstants';
import LogoIcon from 'client/components/LogoIcon.vue';
import UserLoginController from 'client/containers/user/UserLoginController.vue';
import UserLoginForm from 'client/containers/Login/UserLoginForm.vue';

const { redirectTo } = Constants;
const { clientType, clientTypeCookie } = LoginConsts;

export default {
  name: 'UserLoginWrapper',

  components: {
    LogoIcon,
    UserLoginForm,
    ButtonLoginSwitch,
    UserLoginController,
  },

  props: {
    clientType: {
      type: String,
      default: clientType.user,
    },
    error: {
      type: String,
      default: '',
    },
    success: {
      type: String,
      default: undefined,
    },
    redirectTo: {
      type: String,
      default: '',
    },
    requestKey: {
      type: String,
      default: '',
    },
    form: {
      type: Object,
      default: () => ({
        email: '',
        password: '',
      }),
    },
  },

  setup() {
    const { isIdentityFirstFlow } = useFeatureFlags();
    return { isIdentityFirstFlow };
  },

  data: () => ({
    autofocus: '',
  }),

  methods: {
    goToAdminLogin() {
      // removing redirectTo from session to prevent issues when swtiching clientTypes
      sessionStorage.removeItem(redirectTo);
      this.$router.push({
        name: 'Admin Login',
        params: { form: this.form },
      });
    },

    updateAutofocus(lastFocusedInput) {
      this.autofocus = lastFocusedInput;
    },
  },

  mounted() {
    Cookies.set(clientTypeCookie, 'user');
  },

  computed: {
    mfaType() {
      return this.$route.query.mfaType;
    },

    step() {
      return this.$route.query.step;
    },
  },
};
</script>

<style module>
@import '../../css/login-components.css';

.container {
  padding: 1rem;
}
</style>
